// Header intro: the one-time entrance of the nav (bar drops in, "vektr" is
// written, the tools glide in from the right). Plays at most once per day and
// again after every new login (the /login page clears the marker).
//
// The gate must run before first paint, otherwise the static header flashes
// before it animates — hence an inline script in the layout rather than an
// effect. It stamps `data-intro="<t0>"` on <html>; globals.css keys the
// choreography off that attribute and Nav removes it when the sequence ends.

export const HEADER_INTRO_KEY = "vektr-intro";
export const HEADER_INTRO_ATTR = "data-intro";

// Phones (< md, where Nav hides the logo) and reduced motion get no intro.
// `?intro` in the URL forces a replay (for demoing the sequence).
// Paths where Nav renders nothing or a stripped exam header.
const SKIP = String.raw`^\/(m|login|prov-elev)(\/|$)|^\/klass\/[^/]+\/(lektion\/elev-vy|spel\/[^/]+\/projektor)$`;

export const HEADER_INTRO_GATE = `(function(){try{
if(new RegExp(${JSON.stringify(SKIP)}).test(location.pathname))return;
if(matchMedia("(prefers-reduced-motion: reduce), (max-width: 767px)").matches)return;
var d=new Date().toLocaleDateString("sv-SE");
if(localStorage.getItem("${HEADER_INTRO_KEY}")===d&&!/[?&]intro(=|&|$)/.test(location.search))return;
localStorage.setItem("${HEADER_INTRO_KEY}",d);
document.documentElement.setAttribute("${HEADER_INTRO_ATTR}",String(Math.round(performance.now())));
}catch(e){}})();`;

// Where the tools start relative to the bar (ms after t0), and how long the
// intro attribute lingers after that. The tail is generous because the lektion
// bar mounts after its own fetch: anything mounting inside the tail still
// glides in instead of popping.
export const HEADER_INTRO_TOOLS_AT = 560;
// The lektion bar's beat (ms after t0) — deliberately after the tools.
export const HEADER_INTRO_LEFT_AT = 1100;
export const HEADER_INTRO_TAIL = 2400;
